import qs from 'qs'
import SocketService from './SocketService.js'

let moduleName = ''
export function getCurrentModuleName () {
  if (!moduleName) {
    moduleName = qs.parse(window.location.search.slice(1)).m
  }
  return moduleName || ''
}

export function isOfficialModule () {
  return getCurrentModuleName().startsWith('danmaku.')
}

export function createPromise (request, response) {
  return new Promise((resolve, reject) => {
    let uuid = (`${new Date().getTime() % 100000}`).padStart(5, '0') + (`${Math.floor(Math.random() * 100000)}`).padStart(5, '0')
    let responseEvent = response
      ? typeof response === 'string' ? response : response.event
      : request.event
    SocketService.once(`${responseEvent}.${uuid}`, res => {
      if (response && response.handler) {
        response.handler(res, resolve, reject)
      } else {
        if (res.success) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      }
    })
    setTimeout(() => {
      reject(new Error(`请求超时 ${request.event} ${request.data}`))
    }, 3e3)
    SocketService.send(request.event, Object.assign({
      uuid
    }, request.data))
  })
}



// WEBPACK FOOTER //
// ./src/container/utils.js